import { render, staticRenderFns } from "./CupertinoAlertDialog.vue?vue&type=template&id=40ca8491&scoped=true&"
import script from "./CupertinoAlertDialog.vue?vue&type=script&lang=ts&"
export * from "./CupertinoAlertDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CupertinoAlertDialog.vue?vue&type=style&index=0&id=40ca8491&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca8491",
  null
  
)

export default component.exports